import React, {
  Component
} from 'react';
import {
  css
}
from 'emotion';

import {
  borderRadiusBase
}
from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import {
  grayBorder,
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

const containerStyle = css `
  > div {
    border-bottom: .5px solid ${grayBorder};
    border-bottom-left-radius: ${borderRadiusBase || '4px' };
    border-bottom-right-radius: ${borderRadiusBase || '4px' };

    &:last-child {
      border-bottom: none;
    }
  }
`;

export default class Summary extends Component {
  render = () => {
    const {
      className
    } = this.props;
    return (
      <div className={`${containerStyle} ${className || ''}`}>
        { this.props.children }
      </div>
    );
  }
}